import React from "react";
import loadable from "@loadable/component";

export default {
	component: loadable(() => import(/* webpackChunkName: "ContractorSearch" */ "../ContractListing"),{
		fallback: <div>Loading...</div>
	})
};